import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import { useNewsArticles } from '../hooks/useNews';

const styles: SxStyle = {
  switchContainer: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
  },
  progress: {
    marginLeft: '8px',
  },
};

interface Props {
  newsItem: any;
  selectedAbbrv: string;
  isLeague: boolean;
  isReadOnly: boolean;
}

const NewsHideCommentSelect = ({ newsItem, isReadOnly }: Props) => {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { updateNewsArticle } = useNewsArticles();

  const onActiveChanged = async (checked: boolean) => {
    if (isReadOnly) {
      return;
    }
    try {
      setLoading(true);

      await updateNewsArticle({
        id: newsItem.id,
        hiddenComments: !checked,
      });
      newsItem.hiddenComments = !checked;
      const message = !checked
        ? strings.messages.newsHiddenCommentsSuccess
        : strings.messages.newsShowCommentsSuccess;

      enqueueSnackbar(message, {
        variant: 'success',
      });
    } catch (error: any) {
      console.error(error);

      enqueueSnackbar(strings.messages.saveError, {
        variant: 'error',
      });
    } finally {
      // Slight delay to make the loading spinner look a bit nicer
      setTimeout(() => setLoading(false), 500);
    }
  };

  return (
    <Box sx={styles.switchContainer}>
      {loading ? (
        <CircularProgress size={24} sx={styles.progress} />
      ) : (
        <Switch
          size="small"
          checked={!newsItem.hiddenComments}
          onChange={(event, checked) => {
            onActiveChanged(checked);
          }}
          disabled={isReadOnly}
        />
      )}
    </Box>
  );
};

export default NewsHideCommentSelect;
